import { NavLink, Outlet } from "react-router";
import { useT } from "../lib/i18n.tsx";
import { useMe } from "../lib/me.tsx";
import { useMeta } from "../lib/meta.ts";
import { AccountState } from "./AccountState.tsx";
import { Bell } from "./Bell.tsx";
import { YabeLogo } from "./Logo.tsx";
import { TermsPrompt } from "./TermsPrompt.tsx";

const tabs = [
  { to: "/", key: "nav.home", icon: "⌂", end: true },
  { to: "/s", key: "nav.browse", icon: "⌕" },
  { to: "/sell", key: "nav.sell", icon: "+" },
  { to: "/me/watching", key: "nav.watching", icon: "◉" },
  { to: "/me", key: "nav.me", icon: "◯" },
] as const;

export function Layout() {
  const t = useT();
  const { me } = useMe();
  const meta = useMeta();
  return (
    <div className="shell">
      <header className="header">
        <NavLink to="/" className="header__logo" aria-label={t("app.name")}>
          <YabeLogo size={22} />
        </NavLink>
        <nav className="header__nav" aria-label="primary">
          {tabs.slice(1).map((tab) => (
            <NavLink key={tab.to} to={tab.to} className="header__link">
              {t(tab.key)}
            </NavLink>
          ))}
        </nav>
        <div className="header__actions">
          <NavLink to="/s" className="iconbtn" aria-label={t("common.search")}>
            ⌕
          </NavLink>
          <Bell />
          {me ? (
            <NavLink to="/me" className="btn btn--ghost" data-testid="header-me">
              {me.needs_onboarding ? "…" : `@${me.handle}`}
            </NavLink>
          ) : (
            <NavLink to="/login" className="btn btn--ghost" data-testid="header-login">
              {t("nav.login")}
            </NavLink>
          )}
        </div>
      </header>
      <AccountState />
      <TermsPrompt />
      <main className="main">
        <Outlet />
      </main>
      <footer className="footer">
        <NavLink to="/legal/terms">{t("legal.terms")}</NavLink> ·{" "}
        <NavLink to="/legal/privacy">{t("legal.privacy")}</NavLink> ·{" "}
        <NavLink to="/legal/prohibited">{t("legal.prohibited")}</NavLink>
        {meta?.support_url ? (
          <>
            {" "}
            ·{" "}
            <a href={meta.support_url} target="_blank" rel="noopener noreferrer">
              {t("footer.support")}
            </a>
          </>
        ) : null}
        <span className="muted"> · {t("footer.made_in")}</span>
      </footer>
      <nav className="tabbar" aria-label="tabs">
        {tabs.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={"end" in tab ? tab.end : false}
            className={({ isActive }) => `tabbar__item${isActive ? " is-active" : ""}`}
          >
            <span className="tabbar__icon" aria-hidden="true">
              {tab.icon}
            </span>
            <span className="tabbar__label">{t(tab.key)}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
